import { createQueryParams, IData, readQueryParams } from '@cp/src/utils/QueryParamsHelper';
import { ColDefsType } from '@navi/web-ui/lib/components/AgTable/types';
import { Dispatch } from '@reduxjs/toolkit';
import { NavigateFunction } from 'react-router-dom';
import { DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE, sortByMap, UNACK, UNREAD } from './contants';
import { setRequestedFieldSupport, setTasksForMe } from './reducers/CsaCoordinationSlice';
import { IFilterSchema, ITableData, ITableTicket, TableName } from './types';

export const setInitialParams = (
  queryParams: IData,
  navigate: NavigateFunction,
  tableName: TableName
) => {
  if (!queryParams?.[tableName]) queryParams[tableName] = {};

  if (!queryParams[tableName]?.pageNumber) {
    queryParams[tableName].pageNumber = DEFAULT_PAGE_NUMBER;
  }
  if (!queryParams[tableName]?.pageSize) {
    queryParams[tableName].pageSize = DEFAULT_PAGE_SIZE;
  }
  const updatedParams = createQueryParams(queryParams);
  navigate(updatedParams);
};

export const getUpdatedColDefs = (
  colData: ColDefsType[],
  queryParams: IData,
  tableName: TableName
) => {
  return colData.map(item => {
    if (item.field === queryParams?.[tableName]?.sortByField) {
      return {
        ...item,
        serverSort: queryParams?.[tableName]?.sortOrder?.toLowerCase(),
        lastChanged: new Date().getTime()
      };
    }
    delete item.serverSort;
    return item;
  });
};

export const updateAcknowlegementStatus =
  (tickets: ITableData, ticket: ITableTicket, isFieldSupport = false) =>
  (dispatch: Dispatch) => {
    const { referenceId } = ticket || {};
    const { data = [] } = tickets || {};
    const ticketsData = [...data];
    const ticketIndex = ticketsData?.findIndex(
      ticketData => ticketData?.referenceId === referenceId
    );
    if (ticketIndex !== -1) {
      ticketsData[ticketIndex] = {
        ...ticket,
        isAcknowledgedByAssignee: isFieldSupport ? ticket?.isAcknowledgedByAssignee : true,
        newUpdatesCount: 0
      };
      if (isFieldSupport) {
        dispatch(
          setRequestedFieldSupport({
            ...tickets,
            data: ticketsData
          })
        );
        return;
      }
      dispatch(
        setTasksForMe({
          ...tickets,
          data: ticketsData
        })
      );
    }
  };

export const getPayloadForFetchTickets = (isFieldSupport: boolean, userId?: string) => {
  const params = readQueryParams();
  const filterParams = params?.filters;
  const tableParams = params[isFieldSupport ? TableName.FIELD_SUPPORT : TableName.TASKS_FOR_ME];

  const requesters = isFieldSupport ? [userId] : [];
  const assignees = isFieldSupport ? [] : [userId];

  const status = filterParams?.status?.split(',');
  const requestTypes = filterParams?.requestType?.split(',') ?? [];
  const showUnread = tableParams?.showUnread;
  let customerName = '';
  let loanNo = '';

  const searchText = tableParams?.searchText ?? '';
  if (/\d/.test(searchText)) {
    loanNo = searchText;
  } else {
    customerName = searchText;
  }

  const sortByKey = sortByMap[tableParams?.sortByField as keyof typeof sortByMap];
  const sortOrder = tableParams?.sortOrder;
  const isUnread = showUnread === 'true';
  return {
    filters: {
      REQUESTERS: requesters,
      ASSIGNEES: assignees,
      SUPPORT_REQUEST_TYPES: requestTypes,
      CUSTOMER_NAMES: customerName ? [customerName] : [],
      LOAN_ACCOUNT_NUMBERS: loanNo ? [loanNo] : [],
      STATUSES: status,
      ACKNOWLEDGMENT_STATUS: null,
      REQUESTER_COMMENTS_READ_STATUS: isUnread && isFieldSupport ? [UNREAD] : null,
      ASSIGNEE_COMMENTS_READ_STATUS: isUnread && !isFieldSupport ? [UNREAD] : null
    },
    sort: {
      [sortByKey]: sortOrder
    },
    pages: {
      pageNo: Number(tableParams?.pageNumber) - 1,
      pageSize: Number(tableParams?.pageSize)
    }
  };
};

export const getFilterSchema = (data: Record<string, IFilterSchema>) => {
  const transformedObject: Record<string, IFilterSchema> = {};
  for (const key in data) {
    const element = data[key];
    if (element) {
      transformedObject[key] = {
        key: key,
        multiSelect: true,
        isSearchEnabled: false,
        label: element.label,
        options: element.options
      };
    }
  }
  return transformedObject;
};
